import { createSelector } from 'reselect';
import {
  getIndicators,
  getQueryIndicators,
  getQueryDistributions,
  getRouterView,
  getCategories,
} from './basicData';

const idInQuery = (query, id, catHash) => {
  if (catHash) {
    const fullId = `${id}|${catHash}`;
    return query === `${fullId}` ||
    (Array.isArray(query) && -1 < query.indexOf(`${fullId}`));
  }
  return query === `${id}` ||
  (Array.isArray(query) && -1 < query.indexOf(`${id}`));
};

const indicatorWithId = (
  categories,
  indicators,
  query,
  distributions,
  view,
  { id, catHash },
) => {
  const varId = catHash ? `${id}|${catHash}` : id;
  // Conditional for non-mega categories.
  if (!indicators[id] && categories[id]) {
    return {
      id,
      label: categories[id].name,
      children: categories[id].indicators || false,
      checked: !categories[id].indicators ?
        // Only take distributions into account on the table view (3)
        idInQuery(query, varId) && ('3' !== view || !(distributions[varId] || []).length) :
        categories[id].indicators
          .every((child) => idInQuery(query, child, catHash)), // eslint-disable-line no-unused-vars
    };
  }
  return {
    id,
    label: indicators[id].name,
    children: indicators[id].children || false,
    checked: !indicators[id].children ?
      // Only take distributions into account on the table view (3)
      idInQuery(query, varId) && ('3' !== view || !(distributions[varId] || []).length) :
      indicators[id].children
        .every((child) => idInQuery(query, child, catHash)), // eslint-disable-line no-unused-vars
  };
};

const selector = createSelector(
  [
    getCategories,
    getIndicators,
    getQueryIndicators,
    getQueryDistributions,
    getRouterView,
    (state, props) => props,
  ],
  indicatorWithId
);

export default selector;

// Use this to memorize across multiple instances
const makeIndicatorWithId = () => selector;

export {
  indicatorWithId,
  makeIndicatorWithId,
};



// WEBPACK FOOTER //
// ./app/selectors/indicatorWithId.js